import { render, staticRenderFns } from "./CetakLhuAdmin.vue?vue&type=template&id=b72c2812&"
import script from "./CetakLhuAdmin.vue?vue&type=script&lang=js&"
export * from "./CetakLhuAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports